import { render, staticRenderFns } from "./FieldBoolean.vue?vue&type=template&id=6b5c1aa5&"
import script from "./FieldBoolean.vue?vue&type=script&lang=js&"
export * from "./FieldBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports